namespace appn.views.files.downloading {

    class InitArgs {
        action: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        window.location.href = _initArgs.action;
    }
}
